import { PartnerType } from 'Admin/Partners';
import { GrantsType, hasScopedPermission } from '../../Shared/utils/auth';

export const managePartnerPermissionsPolicy = (
  grants: GrantsType,
  context?: PartnerType
) =>
  !context?.isCarrier &&
  hasScopedPermission(grants, 'partner', 'partners.manage_permissions');
